<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        โปรโมชันเด่นของบริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="pull-right box_add" v-if="checkPermission">
                      <button
                        @click="change_view_promotion"
                        style="margin-right:2px;"
                        class="btn btn-info btn_custom"
                      >
                        <i class="fa fa-plus"></i> เพิ่มรายการส่งเสริมการขาย
                      </button>
                      <button
                        @click="change_view_file"
                        style="margin-left:2px;"
                        class="btn btn-warning"
                      >
                        <i class="fa fa-plus"></i> อัปโหลดไฟล์รายการส่งเสริมการขาย
                      </button>
                    </div>
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย" prop="namePromotion">
                            <el-input clearable v-model="form.namePromotion"></el-input>
                          </el-form-item>
                          <el-form-item label="ชนิดของรายการส่งเสริมการขาย" prop="typeOfservice">
                            <el-select filterable v-model="form.promotion_type">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="main"></el-option>
                              <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลาเริ่มต้นการเสนอขาย">
                            <el-select filterable v-model="form.quarter" style="width: 30%">
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>
                            <el-date-picker
                              v-model="form.year"
                              type="year"
                              style="width: 70%"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ผู้ให้บริการ" prop="networkName">
                            <template v-if="provider.length === 1">
                              <el-select
                                filterable
                                v-model="form.provider_id"
                                disabled
                              >
                               <el-option label="ทั้งหมด" value=""></el-option>
                                <el-option
                                  v-for="item in provider"
                                  :key="item.value"
                                  :label="item.brand_name_th"
                                  :value="item.provider_id"
                                ></el-option>
                              </el-select>
                            </template>
                            <template v-if="provider.length > 1">
                              <el-select filterable v-model="form.provider_id">
                                  <el-option label="ทั้งหมด" value=""></el-option>
                                <el-option
                                  v-for="item in provider"
                                  :key="item.value"
                                  :label="item.brand_name_th"
                                  :value="item.provider_id"
                                ></el-option>
                              </el-select>
                            </template>
                          </el-form-item>
                          <el-form-item
                            label="ประเภทบริการของรายการส่งเสริมการขาย"
                            prop="service_type"
                          >
                            <el-select filterable v-model="form.promotion_category">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="ระบบรายเดือน (Postpaid)" value="postpaid"></el-option>
                              <el-option label="ระบบเติมเงิน (Prepaid)" value="prepaid"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="ช่วงราคา (บาท)" class="slider_price">
                            <el-slider
                              v-model="form.priceRange"
                              :step="100"
                              range
                              :max="1600"
                              :show-input="true"
                              :show-stops="true"
                              :format-tooltip="changeTooltip"
                              :marks="{0:'0',100:'100',200:'200',300:'300',400:'400',500:'500',600:'600',700:'700',800:'800',900:'900',1000:'1000',1100:'1100',1200:'1200',1300:'1300',1400:'1400',1500:'1500',1600:'1500 ขึ้นไป'}"
                            ></el-slider>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="loadData(null, form)">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <div class="box-body">
                  <div style="padding-bottom: 20px" align="right">
                    <el-button @click="get_download_data()" type="primary">Export Excel</el-button>
                  </div>
                  <data-tables-server
                    @query-change="loadData"
                    :data="data_table"
                    :total="total"
                    :current-page.sync="page"
                    :page-size="10"
                    :pagination-props="{
                      background: true,
                      pageSizes: [10, 20, 50]
                    }"
                    :row-style="tableRowStyle"
                  >
                    <el-table-column class-name="code" sortable="custom" prop="promotion_code" label="รหัสรายการส่งเสริมการขาย" width="220" :render-header="test"></el-table-column>
                    <el-table-column class-name="name" sortable="custom" prop="promotion_name_th" label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" width="290"></el-table-column>
                    <el-table-column class-name="name" sortable="custom" prop="promotion_name_en" label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)" width="290"></el-table-column>
                    <el-table-column class-name="category" sortable="custom" prop="promotion_category" label="ประเภทบริการของรายการส่งเสริมการขาย" width="310">
                      <template slot-scope="scope">
                        {{ scope.row.promotion_category }}
                      </template>
                    </el-table-column>
                    <el-table-column class-name="type" sortable="custom" prop="promotion_type" label="ชนิดของรายการส่งเสริมการขาย" width="250">
                      <template slot-scope="scope">
                        {{ scope.row.promotion_type }}
                      </template>
                    </el-table-column>
                    <el-table-column label="จำนวนวันในการให้บริการของรายการส่งเสริมการขายเสริม (เฉพาะ On-Top)" align="center">
                      <el-table-column class-name="service_days" prop="number_of_service_days" label="(วัน)" sortable="custom" align="center" width="260">
                        <template slot-scope="scope" >
                          {{ scope.row.number_of_service_days }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="ระยะเวลา" align="center">
                      <el-table-column class-name="date" sortable="custom" prop="start_sale_date" label="เริ่มต้นของการเสนอขาย" width="200">
                        <template slot-scope="scope">
                          {{ scope.row.start_sale_date == null ? "" : moment(scope.row.start_sale_date).add(543, 'Y').format('DD/MM/YYYY') }}
                        </template>
                      </el-table-column>
                      <el-table-column class-name="date" sortable="custom" prop="end_sale_date" label="สิ้นสุดของการเสนอขาย" width="200">
                        <template slot-scope="scope">
                          {{ scope.row.end_sale_date == null ? "" : moment(scope.row.end_sale_date).add(543, 'Y').format('DD/MM/YYYY') }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column class-name="price" sortable="custom" prop="promotion_price" label="ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน (บาท)" width="200px"></el-table-column>
                    <el-table-column label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ" align="center">
                      <el-table-column label="บริการเสียง" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="voice_minute" label="(นาที)" width="90px"></el-table-column>
                        <el-table-column class-name="service" sortable="custom" prop="voice_second" label="(วินาที)" width="100px"></el-table-column>
                        <el-table-column class-name="service" prop="voice_remark_th" label="เงื่อนไข (ภาษาไทย)" show-overflow-tooltip width="160px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ SMS" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="sms_amount" label="(ข้อความ)" width="120px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ MMS" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="mms_amount" label="(ข้อความ)" width="120px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ Internet " align="center">
                        <el-table-column class-name="service" sortable="custom" prop="internet_MB" label="(MB)" width="80px"></el-table-column>
                        <el-table-column class-name="service" sortable="custom" prop="internet_GB" label="(GB)" width="80px"></el-table-column>
                        <el-table-column class-name="service" prop="internet_remark_th" label="เงื่อนไข (ภาษาไทย)" show-overflow-tooltip width="170px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="ความเร็ว Internet" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="internet_speed_Kbps" label="(Kbps)" width="100px"></el-table-column>
                        <el-table-column class-name="service" sortable="custom" prop="internet_speed_Mbps" label="(Mbps)" width="100px"></el-table-column>
                        <el-table-column class-name="service" sortable="custom" prop="internet_speed_remark_th" label="เงื่อนไข (ภาษาไทย)" show-overflow-tooltip width="170"></el-table-column>
                      </el-table-column>
                      <el-table-column label="WiFi" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="wifi_service_th" label="คำอธิบาย (ภาษาไทย)" show-overflow-tooltip width="190px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="Others" align="center">
                        <el-table-column class-name="service" sortable="custom" prop="other_service_th" label="คำอธิบาย (ภาษาไทย)" show-overflow-tooltip width="190px"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="อัตราค่าบริการเฉลี่ย" align="center">
                      <el-table-column label="บริการเสียง" align="center">
                        <el-table-column class-name="average" sortable="custom" prop="voice_per_minute" label="(บาท/นาที)" width="120px"></el-table-column>
                        <el-table-column class-name="average" sortable="custom" prop="voice_per_second" label="(บาท/วินาที)" width="120px"></el-table-column>
                        <el-table-column class-name="average" sortable="custom" prop="voice_remark" label="เงื่อนไขอื่นๆ" width="160px" show-overflow-tooltip></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ SMS" align="center">
                        <el-table-column class-name="average" sortable="custom" prop="sms_per_message" label="(บาท/ข้อความ)" width="140px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ MMS" align="center">
                        <el-table-column class-name="average" sortable="custom" prop="mms_per_message" label="(บาท/ข้อความ)" width="140px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ Internet" align="center">
                        <el-table-column class-name="average" sortable="custom" prop="internet_per_MB" label="(บาท/MB)" width="120px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="WiFi" align="center">
                        <el-table-column class-name="average" prop="wifi_average" label="คำอธิบาย" width="120px" show-overflow-tooltip></el-table-column>
                      </el-table-column>
                      <el-table-column label="Others" align="center">
                        <el-table-column class-name="average" prop="other_average" label="คำอธิบาย" width="120px" show-overflow-tooltip></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column class-name="charge_type" sortable="custom" prop="service_charge_type" label="รูปแบบการคิดค่าบริการประเภทเสียง (วินาที/นาที)" width="240px" align="center"></el-table-column>
                    <el-table-column class-name="condition" prop="promotion_condition_th" label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)" show-overflow-tooltip width="350px"></el-table-column>
                    <el-table-column label="สิทธิพิเศษ (ไม่มีค่าบริการ)" align="center">
                      <el-table-column class-name="privilege" prop="privilege_content_th" label="ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาไทย)" show-overflow-tooltip width="350px"></el-table-column>
                      <el-table-column class-name="privilege" prop="privilege_social_th" label="ให้บริการโซเชียลมีเดีย (ภาษาไทย)" show-overflow-tooltip width="270px"></el-table-column>
                      <el-table-column class-name="privilege" prop="privilege_game_th" label="ให้บริการเกม (ภาษาไทย)" show-overflow-tooltip width="210px"></el-table-column>
                      <el-table-column class-name="privilege" prop="privilege_premium_th" label="พรีเมียม (ภาษาไทย)" show-overflow-tooltip width="200px"></el-table-column>
                      <el-table-column class-name="privilege" prop="privilege_device_th" label="อุปกรณ์อื่นๆ (ภาษาไทย)" show-overflow-tooltip width="220px"></el-table-column>
                      <el-table-column class-name="privilege" prop="privilege_other_th" label="ให้บริการอื่นๆ (ภาษาไทย)" show-overflow-tooltip width="210px"></el-table-column>
                    </el-table-column>
                    <el-table-column class-name="promotion_url" prop="promotion_link_url" label="ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ" width="280px">
                      <template slot-scope="scope">
                        {{ scope.row.promotion_link_url ? decodeURI(scope.row.promotion_link_url) : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="จัดการ" width="80" align="center" fixed="right" >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <modalView
                    :info="info"
                    :dialog="dialog"
                    @checkModal="closeModal"
                  ></modalView>
                  <el-dialog
                    title="ลบข้อมูลโทรศัพท์เคลื่อนที่"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose"
                  >
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false"
                        >ยกเลิก</el-button
                      >
                      <el-button type="primary" @click="dialogVisible = false"
                        >ยืนยัน</el-button
                      >
                    </span>
                  </el-dialog>
                  <!-- ////dialog -->
                </div>
              </div>
              <!-- ///table -->
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
.code {
  background-color: #b3d9ff;
}
.name ,.separate_price {
  background-color: #ffffcc;
}
.category ,.privilege {
  background-color: #ffe6e6;
}
.type ,.service {
  background-color: #f2f2f2
}
.service_days {
  background-color: #ccffee
}
.date ,.average {
  background-color: #cce6ff
}
.price {
  background-color: #d9f2e6
}
.charge_type {
  background-color: #ffd9b3
}
.condition {
  background-color: #ffcccc
}
.promotion_url {
 background-color: #eeccff
}
</style>
<script>
import { mapState, mapActions } from "vuex";
// import modalView from "../Modal/Modal_mobile_promotion";
import modalView from "../Modal/Modal_mobile_popular";
import moment from 'moment';
var json2csv = require('json2csv')
const { Parser } = require('json2csv');
let CsvExport = function(data, fields, fileName) {
  try {
    const parser = new Parser({fields});
    const result = parser.parse(data);
    let temp = result
    // var csvContent = 'data:text/csvcharset=GBK,\uFEFF' + encodeURIComponent(result)
    // var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + escape(temp)
    var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(result)
    var link = document.createElement('a')
    document.body.appendChild(link)
    link.setAttribute('href', csvContent)
    // link.setAttribute('download', `${(fileName || 'file')}.csv`)
    link.setAttribute('download', `${(fileName || 'file')}.xls`)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error(err)
  }
}
export default {
  components: {
    modalView: modalView
  },
  data() {
    return {
      dialog: false,
      checkPermission: false,
      type_sale: "",
      dialogVisible: false,
      label_position: "top",
      page: 1,
      form: {
        provider_id: "",
        namePromotion: "",
        networkName: "",
        promotion_type: "",
        promotion_category: "",
        dateRange: [new Date(), new Date()],
        quarter: moment(new Date()).quarter(),
        year: moment(new Date()).add('y').format('YYYY'),
        priceRange: [0, 1600]
      },
      dialogFormVisible: false,
      // tableProps: {
      //   border: false,
      //   stripe: true,
      //   page: 1
      // },
      info: {
        promotion_code: ""
      }
    };
  },
  computed: {
    ...mapState({
      provider: store => store.Report_popular_mobile.provider,
      data_table: store => store.Report_popular_mobile.data_table,
      loading: store => store.Report_popular_mobile.loading,
      total: store => store.Report_popular_mobile.total,
      download_form: store => store.Report_popular_mobile.download_form,
      download_data: store => store.Report_popular_mobile.download_data,
      fields: store => store.Report_popular_mobile.fields
    })
  },
  watch:{
    download_data: {
      handler : function(reload, empty) {
        this.exportAll(reload)
      }
    }
  },
  mounted() {
    this.setProvider()
  },
  methods: {
    ...mapActions({
      setProvider: "Report_popular_mobile/setProvider",
      searchPopularPromotion: "Report_popular_mobile/searchPopularPromotion",
      download: "Report_popular_mobile/downloadPopularPromotion"
    }),
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'test'
      }
    },
    tableRowStyle({ row, rowIndex }) {
      return 'background-color: pink'
    },
    test(h,{column, $index}) {
      return column.label
    },
    get_download_data() {
      this.download(this.download_form)
    },
    exportAll(data) {
      let fields = this.fields
      console.log(data)
      console.log(fields)
      CsvExport(data, fields, 'Popular_pro_mobile')
    },
    loadData(queryInfo, form) { 
      if (queryInfo) {
        if(queryInfo.type == 'sort'){
          this.form.sort = {
            prop: queryInfo.sort.prop,
            order: queryInfo.sort.order
          }
        } 
        let set_data = {
          page: queryInfo.page,
          pageSize: queryInfo.pageSize,
          form: this.form
        };
        this.searchPopularPromotion(set_data);
      } else {
        this.page = 1
        let set_data = { page: 1, pageSize: 10, form: form };
        this.searchPopularPromotion(set_data);
      }
    },
    handleClose(done) {
      done();
    },
    changeTooltip(value) {
      if (value == 1600) {
        return "1500 ขึ้นไป";
      }
      return value;
    },
    handleView(row) {
      this.dialog = true;
      this.info = row;
    },
    closeModal(value) {
      this.dialog = value;
    }
  }
};
</script>
